import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  CanAuthenticationGuard,
  AccessRightNewRespInfo,
  BlockPageAuthGuard,
} from '../../utils/authguard';
import { PortailComponent } from './portail.component';
import { MaterialModule } from 'src/app/material/material.module';
import { ServicesMiniComponent } from '../shared/services-mini/services-mini.component';
import { ServicesMaxiComponent } from '../shared/services-maxi/services-maxi.component';
import { ServicesListComponent } from '../shared/services-list/services-list.component';
import { FilterPipe } from '../../pipes/filter.pipe';

const routes = [
  {
    path: 'portail',
    component: PortailComponent,
    canActivate: [
      CanAuthenticationGuard,
      AccessRightNewRespInfo,
      BlockPageAuthGuard,
    ],
  },
];

@NgModule({
  declarations: [PortailComponent],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    MaterialModule,
    ServicesMiniComponent,
    ServicesMaxiComponent,
    ServicesListComponent,
    FilterPipe,
  ],
  exports: [PortailComponent],
  providers: [CanAuthenticationGuard],
})
export class PortailModule {}
